import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { FormLabel, Select } from '@tq/ui-components';

import { filterSelectStyle } from 'styles';
import { IsRegisteredCheckboxProps } from './IsRegisteredCheckbox';
import { ValueLabel } from '../../types';

type IsRegisteredDropDownProps = IsRegisteredCheckboxProps & {
  options: ValueLabel<string>[];
};

export const IsRegisteredDropDown: React.FC<IsRegisteredDropDownProps> = ({
  options,
  label,
  recoilState,
  inputId,
  defaultValue,
}) => {
  const [isRegistered, setIsRegistered] = useRecoilState(recoilState);

  useEffect(() => {
    if (defaultValue) setIsRegistered(defaultValue);
  }, [setIsRegistered, defaultValue]);

  return (
    <>
      <FormLabel htmlFor={inputId} mb={{ base: 0, lg: '.75rem' }}>
        {label}
      </FormLabel>
      <Select
        inputId={inputId}
        onChange={(value) => setIsRegistered(value)}
        defaultValue={defaultValue ?? isRegistered}
        sx={filterSelectStyle}
        aria-label='Is registered'
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
    </>
  );
};
